export type PaginationType = {
    count?: number;
    items_per_page: number;
    page: number;
    total_count?: number;
    total_pages?: number;
};

export const DEFAULT_PAGINATION: PaginationType = {
    items_per_page: 10,
    page: 1,
};
